import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import 'rxjs/Rx';
import { Globals } from '../../globals';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class TemplatesService {

    url: string = `${this._Globals.serviceUrl}TemplatesService.svc/`; 

    constructor(
        private httpClient: HttpClient,
        private _Globals: Globals
    ) { }

    getEmailTemplatesByAssessment(assessmentId: number) {

        let url = `${this.url}GetEmailTemplatesByAssessment?assessmentId=${assessmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getEmailTemplatesByUser() {

        let url = `${this.url}GetEmailTemplatesByUser?userId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getEmailTemplatesByUserByPurpose(purpose: number) {

        let url = `${this.url}GetEmailTemplatesByUserByPurpose?userId=${this._Globals.getUserId()}&purpose=${purpose}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getEmailTemplatesByUserByType(assessmentType: number) {
        let url = `${this.url}GetEmailTemplatesByUserByType?assessmentType=${assessmentType}&userId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //?userId={userId}&purpose={purpose}&userType={userType}
    getEmailTemplatesByUserByUserTypeByPurpose(purpose: number, userType:number) {
        let url = `${this.url}GetEmailTemplatesByUserByUserTypeByPurpose?userId=${this._Globals.getUserId()}&purpose=${purpose}&userType=${userType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getGlobalEmailTemplates() {
        let url = `${this.url}GetGlobalEmailTemplates`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //{"input":{"TemplateId":[TEMPLATE ID],"Language":"[LANGUAGE]"}}
    public postPreviewEmailTemplate(templateId: number, language: string): Observable<any> {
        let url = `${this.url}PreviewEmailTemplate`;

        let body: any = {
            "input": {
                "TemplateId": templateId,
                "Language": language
            }
        }

        body = JSON.stringify(body);
        console.log('PreviewEmailTemplate body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    getEmailTemplate(templateId: number) {

        let url = `${this.url}GetEmailTemplate?templateId=${templateId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getEmailTemplates() {

        let url = `${this.url}GetEmailTemplates`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getEmailTemplatesByPurpose(purpose: number) {
        let url = `${this.url}GetEmailTemplatesByPurpose?purpose=${purpose}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getEmailTemplatesByUserTypeByPurpose(userType: number, purpose: number) {

        let url = `${this.url}GetEmailTemplatesByUserTypeByPurpose?userType=${userType}&purpose=${purpose}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getGlobalEmailTemplatesByType(assessmentType: number) {
        let url = `${this.url}GetGlobalEmailTemplatesByType?assessmentType=${assessmentType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getTemplatesByUserType(userType: number) {

        let url = `${this.url}GetTemplatesByUserType?userType=${userType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    //{ "template": { 
    //"TemplateId": 0,
    //"Name": "Test 2",
    //"AssessmentType": 1,
    //"Purpose": 1,
    //"Niche": 1,
    //"Owner": 5,
    //"Localizations": [{
    //    "Language": "en",
    //    "Subject": "Test 2 subject",
    //    "Body": "<span>This is the body</span>"
    //}]
    //}}
    public postSaveEmailTemplate(template: EmailTemplateDto): Observable<any> {
        let url = `${this.url}SaveEmailTemplate`;

        let postSaveSectionChoice: any = {
            "template": {
                "TemplateId": template.TemplateId,
                "Name": template.Name,
                "AssessmentType": template.AssessmentType,
                "Purpose": template.Purpose,
                "Niche": template.Niche,
                "Owner": template.Owner,
                "Localizations": template.Localizations,
                "UserType": template.UserType,
                "IsGlobal": template.IsGlobal
            }
        };

        let body = JSON.stringify(postSaveSectionChoice);
        console.log('body postSaveQuestion: ' + body);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postPreviewEmailTemplateSendingTemplate(subject: string, body: string): Observable<any> {
        const url = `${this.url}PreviewEmailTemplateSendingTemplate`;
        const requestBody = {
            subject,
            body,
            coachId: this._Globals.getUserId()
        };
        console.log('body postPreviewEmailTemplateSendingTemplate: ' + requestBody);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, requestBody, { headers });
    }

    public existsEmailTemplateName(templateName: string, templateId: number): Observable<{ result: { Result: number, Data: string } }> {
        const url = `${this.url}ExistEmailTemplateName?userId=${this._Globals.getUserId()}&templateName=${templateName}&templateId=${templateId}`;
        // const url = `http://localhost:54541/TemplatesService.svc/ExistEmailTemplateName?userId=${this._Globals.getUserId()}&templateName=${templateName}&templateId=${templateId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get<{ result: { Result: number, Data: string } }>(url, { headers: headers });
    }
}

@Injectable()
export class EmailTemplateDto {
    TemplateId: number;
    Name: string;
    AssessmentType: number;
    Purpose: number;
    Niche: number;
    Owner: number;
    Localizations: LocalizationsEmailTemplate[];
    UserType: number;
    IsGlobal: boolean;
}

@Injectable()
export class LocalizationsEmailTemplate {
    Language: string;
    Subject: string;
    Body: string;
}